import { Editor, Extensions } from '@tiptap/react';
import { TiptapCollabProvider } from '@tiptap-pro/provider';
import * as Y from 'yjs';
import { OnSuccessContext } from '@tiptap-pro/extension-ai';

import { SnapshotState } from 'Tiptap/stores/EditorStore';

import { createCoreExtensions } from './extensions/core';
import { createCollaborationExtensions } from './extensions/collaboration';
import { createAIExtensions } from './extensions/ai';
import { createMediaExtensions } from './extensions/media';
import { createCommentsExtensions } from './extensions/comments';
import { createExportExtensions } from './extensions/export';

export interface EditorConfigOptions {
  provider: TiptapCollabProvider;
  ydoc: Y.Doc;
  entityId: string;
  editable: boolean;
  aiConfig: {
    token: string;
    onLoading?: () => void;
    onChunk?: (data: { response: string }) => void;
    onSuccess?: (context: OnSuccessContext) => void;
    onError?: (error: Error, context: { editor: Editor }) => void;
  };
  onSnapshotUpdate?: (state: SnapshotState) => void;
  onClickThread: (id: string | null) => void;
  onMediaError?: (message: string) => void;
}

export function createEditorConfig(options: EditorConfigOptions): Extensions {
  const { provider, ydoc, entityId, editable, aiConfig, onSnapshotUpdate, onClickThread, onMediaError } = options;

  return [
    ...createCoreExtensions({ ydoc }),
    ...createCollaborationExtensions({
      provider,
      ydoc,
      onSnapshotUpdate,
    }),
    ...createAIExtensions(aiConfig),
    ...createMediaExtensions({
      entityId,
      editable,
      onError: onMediaError,
    }),
    ...createExportExtensions(),
    ...createCommentsExtensions({
      provider,
      onClickThread,
    }),
  ];
}
